import { render, staticRenderFns } from "./NormalCard.vue?vue&type=template&id=41324670&scoped=true&"
import script from "./NormalCard.vue?vue&type=script&lang=js&"
export * from "./NormalCard.vue?vue&type=script&lang=js&"
import style0 from "./NormalCard.vue?vue&type=style&index=0&id=41324670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41324670",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41324670')) {
      api.createRecord('41324670', component.options)
    } else {
      api.reload('41324670', component.options)
    }
    module.hot.accept("./NormalCard.vue?vue&type=template&id=41324670&scoped=true&", function () {
      api.rerender('41324670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/CardContainers/NormalCard.vue"
export default component.exports